<template>
  <blockquote class="quote-block">
    <q-icon name="format_quote" size="28px" class="quote-mark" />
    <p class="quote-text">{{ block.text }}</p>
    <cite v-if="block.attribution" class="quote-attribution">
      <span class="quote-dash">&mdash;</span>
      {{ block.attribution }}
    </cite>
  </blockquote>
</template>

<script setup lang="ts">
interface QuoteBlock {
  type: 'quote';
  text: string;
  attribution?: string;
}

defineProps<{ block: QuoteBlock }>();
</script>

<style scoped lang="scss">
.quote-block {
  position: relative;
  border-left: 4px solid var(--oa-gold-full);
  padding: 18px 22px 18px 28px;
  margin: 24px 0;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--oa-gold-full) 6%, var(--oa-bg-2)) 0%,
    var(--oa-bg-2) 100%
  );
  border-radius: 0 var(--oa-radius-lg) var(--oa-radius-lg) 0;
}

.quote-mark {
  position: absolute;
  top: 8px;
  left: 12px;
  color: color-mix(in srgb, var(--oa-gold-full) 30%, transparent);
  pointer-events: none;
}

.quote-text {
  color: var(--oa-text-primary);
  font-style: italic;
  line-height: 1.65;
  font-size: var(--oa-text-lg);
  font-weight: 500;
  margin: 0 0 8px 0;
  padding-left: 32px;
}

.quote-attribution {
  display: block;
  margin-top: 8px;
  padding-left: 32px;
  color: var(--oa-gold-full);
  font-size: var(--oa-text-sm);
  font-style: normal;
  font-weight: 600;
}

.quote-dash {
  margin-right: 4px;
}
</style>
